module.exports = __webpack_public_path__ + "static/media/gris2.d3628ec4.jpg";